import React, { Component } from 'react'
import { connect } from 'react-redux'
import * as moment from 'moment';
import 'moment/locale/th';
import NumberFormat from 'react-number-format'
import { IMAGE_FULL_URL  } from '../../../config/config'; // IMAGE_THUMB_URL
import PreviewImage from '../../../views/PreviewImage/'
import {  Modal, ModalBody } from 'reactstrap';

class ExpenseListRow extends Component {
    constructor(props) {
        super(props)
        this.state = {
            user: {},
            preview_image_url: '',
            preview_image_select: false
        }
        this.togglePreviewImage = this.togglePreviewImage.bind(this)
    }

  componentWillMount () {
    //const queryString = require('query-string');
    this.setState({
      user: JSON.parse(this.props.user),
    })
  }

    onPreviewSelected(url){
        this.setState({
            preview_image_url: url,
            preview_image_select: true
        });
    }

    togglePreviewImage() {
        this.setState({
            preview_image_select: !this.state.preview_image_select
        });
    }


    render(){
        let expenseList = this.props.expense_list.map((expense,index)=>{
            return (
                <tr key={index}>
                    <td className="text-center">{index+1}</td>
                    <td className="text-center">{moment(expense.expense_date).locale('th').format('LL')}</td>
                    <td className="text-center">{expense.branch_name}</td>
                    <td className="text-center">{expense.expense_name}</td>
                    <td className="text-center">
                        <img
                            src={IMAGE_FULL_URL + expense.expense_image_file}
                            className="img-cars"
                            style={{'cursor':'pointer', width: 100, height: 120}}
                            alt="เอกสาร"
                            onClick={()=>this.onPreviewSelected(IMAGE_FULL_URL + expense.expense_image_file)}
                        />
                    </td>
                    <td className="text-center">
                        <NumberFormat value={expense.expense_amount}
                                      displayType={'text'}
                                      thousandSeparator={true}
                                      prefix={'฿'}/>
                    </td>
                    <td className="text-center">
                        {expense.fullname}
                        <br/>
                        {moment(expense.updated_at).locale('th').format('DD-MM-YYYY HH:mm')}
                    </td>
                    <td className={this.state.user.type==='admin'? "text-center" : "hidden" }>
                      <button className="btn btn-sm btn-danger btn-md-width"
                              onClick={() => this.props.onDeleteHandle(expense)}
                      >
                        <i className="fa fa-remove"></i> ลบ
                      </button>
                    </td>
                </tr>
            )
        });

        return (
            <div className="card-block">
                <table className="table table-striped">
                    <thead>
                    <tr>
                        <th className="text-center">#</th>
                        <th className="text-center">วันที่ใช้จ่าย</th>
                        <th className="text-center">สาขา</th>
                        <th className="text-center">รายละเอียด</th>
                        <th className="text-center">ไฟล์เอกสาร</th>
                        <th className="text-center">ยอดจ่าย</th>
                        <th className="text-center">ผู้บันทึก</th>
                        <th className={this.state.user.type==='admin'? "text-center" : "hidden" }>
                         ลบ
                        </th>
                    </tr>
                    </thead>
                    <tbody>
                    {expenseList}
                    </tbody>
                </table>

                <Modal isOpen={this.state.preview_image_select} toggle={this.togglePreviewImage} className={'modal-lg '}>
                    <ModalBody>
                        <PreviewImage
                            imageUrl={this.state.preview_image_url}
                        />
                    </ModalBody>
                </Modal>
                {/*<ul className="pagination">
                    <li className="page-item"><a className="page-link" href="#">Prev</a></li>
                    <li className="page-item active">
                        <a className="page-link" href="#">1</a>
                    </li>
                    <li className="page-item"><a className="page-link" href="#">2</a></li>
                    <li className="page-item"><a className="page-link" href="#">3</a></li>
                    <li className="page-item"><a className="page-link" href="#">4</a></li>
                    <li className="page-item"><a className="page-link" href="#">Next</a></li>
                </ul>*/}
            </div>
        )
    }
}

const mapStateToProps = (state) => ({
    user: state.auth.user,
    token: state.auth.token,
    isAuthenticated: state.auth.isAuthenticated
})

export default connect(mapStateToProps)(ExpenseListRow)
